import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/fa/heart-regular.svg")